import {
    SHOW_ERROR,
    ADD_PRODUCT,
    FETCH_PRODUCTS,
    EDIT_PRODUCT,
} from './types';
import errorObject from '../components/helpers/errorObject';
import auth from '../apis/auth';

export const addProduct = (formValues) => async dispatch => {
    await auth.post('/api/product/create_product', formValues)
        .then(response => {
            dispatch({ type: ADD_PRODUCT, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export const fetchProducts = () => async dispatch => {
    await auth.get('/api/product/get_products')
        .then(response => {
            dispatch({ type: FETCH_PRODUCTS, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
            // history.push('/products')
        })
}

export const editProduct = (id, formValues) => async dispatch => {
    await auth.patch(`/api/product/update_product?id=${id}`, formValues)
        .then(response => {
            dispatch({ type: EDIT_PRODUCT, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}